// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"layoutWrapper--VevnJ","contentWrapper":"contentWrapper--s6e3s"};